import { connect } from 'react-redux'
import DriverViewSessionHistory from '../../components/drivers/DriverViewSessionHistory'
import { IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: { operatorId: string }) {
  const operatorId = ownProps.operatorId
  const currentOperator = state.drivers.items[operatorId]
  return {
    operatorId,
    sessionHistory: Object.values(state.drivers.sessionHistory),
    operatorName: `${currentOperator.name}`
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverViewSessionHistory)



// WEBPACK FOOTER //
// ./src/containers/drivers/DriverViewSessionHistory.ts